/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FollowDealerButton_seller$ref = any;
export type RequestShippingSuccessContent_seller$ref = any;
export type RequestShippingSuccessContent_seller = {
    readonly " $fragmentRefs": FollowDealerButton_seller$ref;
    readonly " $refType": RequestShippingSuccessContent_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "RequestShippingSuccessContent_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "FollowDealerButton_seller",
            "args": null
        }
    ]
} as any);
(node as any).hash = '25f08c065b495b3b34ff55f8975acff2';
export default node;
